import React from 'react';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Apertura2015 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [848];
	for (var i = 852; i <= 875; i++) {
              if(i!==853 && i!==856 && i!==858 && i!==861 && i!==863 && i!==864 && i!==868 && i!==870){
        	id_list.push(i);
		}
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
kit_path: '/images/kits/todas/',
      kits: [],
      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':15, 'pg':4,'pe':1,'pp':10,'gf':18,'gc':24,'dif':-6, 'pts':13},
              {'color':'#295e1e','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':15, 'pg':7,'pe':5,'pp':3,'gf':22,'gc':19,'dif':3, 'pts':26},
	     {'color':0,'shortname':'arica', 'rivalName':'San Marcos', 'pj':15, 'pg':5,'pe':2,'pp':8,'gf':18,'gc':20,'dif':-2, 'pts':17},
              {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':15, 'pg':4,'pe':4,'pp':7,'gf':20,'gc':28,'dif':-8, 'pts':16},
	      {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':15, 'pg':9,'pe':1,'pp':5,'gf':29,'gc':19,'dif':10, 'pts':28},
              {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':15, 'pg':10,'pe':2,'pp':3,'gf':33,'gc':15,'dif':18, 'pts':32},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':15, 'pg':11,'pe':0,'pp':4,'gf':24,'gc':14,'dif':10, 'pts':33},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':15, 'pg':6,'pe':0,'pp':9,'gf':23,'gc':28,'dif':-5, 'pts':18},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':15, 'pg':4,'pe':4,'pp':7,'gf':16,'gc':21,'dif':-5, 'pts':16},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':15, 'pg':4,'pe':5,'pp':6,'gf':24,'gc':30,'dif':-6, 'pts':17},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':15, 'pg':4,'pe':3,'pp':8,'gf':13,'gc':27,'dif':-14, 'pts':15},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':15, 'pg':2,'pe':5,'pp':8,'gf':11,'gc':23,'dif':-12, 'pts':11},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':15, 'pg':7,'pe':3,'pp':5,'gf':30,'gc':20,'dif':10, 'pts':24},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':15, 'pg':7,'pe':2,'pp':6,'gf':23,'gc':23,'dif':0, 'pts':23},
              {'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':15, 'pg':8,'pe':4,'pp':3,'gf':23,'gc':17,'dif':6, 'pts':28},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':15, 'pg':5,'pe':5,'pp':5,'gf':20,'gc':19,'dif':1, 'pts':20}]

    };
  }

  componentDidMount() {
	this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});

	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Liguilla');
  return(


	<div style={{textAlign: 'center' }}>

	          <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Apertura 2015</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}
	 
	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Apertura 2015</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Apertura 2015</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Apertura 2015" />
     </div>


  )
}

}
export default Apertura2015;
